// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__27Mo1","success":"FinishedQuiz_success__1JIed","error":"FinishedQuiz_error__1NK2Y"};